import Layout from "../../../components/Layout/Layout";
import { useEffect, useState } from "react";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import DetailsText from "../../leavemgt/components/DetailsText";
import useStyles from "../styles";
import Modal from "../../../components/Modal";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge/Badge";
import Button from "../../../components/Button/Button";
import { Icon } from "@iconify/react";
import { httprequest } from "../../../data/api";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const LEAVE_MGT_DETAILS_ENDPOINT = "/admin/v1/leave";
// --/ GET ALL LEAVE ENDPOINT
// const APPLY_LEAVE = "/admin/v1/leave";

const LeaveMgtDetails = () => {
  const { id } = useParams();
  const classes = useStyles();
  const [isApproving, setIsApproving] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [declineModal, setDeclineModal] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);
  // FOR API INTEGRATION
  const [memberleave, setMemberLeave] = useState([]);

  const handleApproveModal = () => {
    setApproveModal(true);
  };

  const handleCloseDeclineModal = () => {
    setDeclineModal(false);
  };

  const handleDeclineModal = () => {
    setDeclineModal(true);
  };

  const handleCloseApproveModal = () => {
    setApproveModal(false);
  };

  const getMemberLeaveInfo = () => {
    httprequest.get(`${LEAVE_MGT_DETAILS_ENDPOINT}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data);
      setMemberLeave(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };
  // eslint-disable-next-line no-console
  console.log(memberleave);

  const handleApproveLeave = () => {
    setIsApproving(true);
    httprequest.patch(`${LEAVE_MGT_DETAILS_ENDPOINT}/${id}`).then((res) => {
      setIsApproving(false);
      handleCloseApproveModal();
      toast.success(res?.data?.message);
    }).catch((err) => {
      setIsApproving(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleDeclineLeave = () => {
    setIsDeclining(true);
    httprequest.patch(`${LEAVE_MGT_DETAILS_ENDPOINT}/${id}`).then((res) => {
      setIsDeclining(false);
      handleCloseApproveModal();
      toast.success(res?.data?.message);
    }).catch((err) => {
      setIsDeclining(false);
      toast.error(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    // The data will be from the inventory get api endpint
    getMemberLeaveInfo();
  }, []);

  return (
    <Layout
      children={
        <>
          <BreadCrumb link_one={`/schools/${memberleave?.org_id}`} link_one_name="Leave Management" active="Leave Details" description={`See the leave details of ${`${memberleave?.first_name} ${memberleave?.last_name}`}`} />
          <hr className={classes.pagedivider} />
          <Grid container spacing={4}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="Name" subtitle={`${`${memberleave?.first_name} ${memberleave?.last_name}`}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <DetailsText title="Status" subtitle={<Badge status={`${memberleave?.leave_status}`} />} />
              </Grid>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="From" subtitle={`${memberleave?.start_date?.substring(0, 10)}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="To" subtitle={`${memberleave?.end_date?.substring(0, 10)}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="Title" subtitle={`${memberleave?.role}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="Approved By" subtitle={`${memberleave?.approved_by}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="Leave Type" subtitle={`${memberleave?.type}`} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DetailsText title="No of Days" subtitle={`${memberleave?.number_of_days}`} />
            </Grid>
            <Grid item lg={6} md={8} sm={8} xs={12}>
              <DetailsText title="Leave Description" subtitle="Remember to tailor these options to match your organization's specific leave policies and terminology. Additionally, consider providing clear tooltips or guidance within the system to help users understand the purpose of each dropdown option." />
            </Grid>
          </Grid>
          <Grid container spacing={4} marginTop={1}>
            {/* <Grid item lg={3} md={4} sm={6} xs={12}>
            <Button buttonName="Reschedule leave" variant="dangeroutline" buttonIcon={<Icon icon="carbon:close-filled" />} color="btndanger" buttonSize="full" />
          </Grid> */}
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Button buttonName="Approve Request" variant="success" buttonIcon={<Icon icon="mdi:checkbox-marked-circle-outline" />} color="btndefault" buttonSize="full" onClick={handleApproveModal} />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <Button buttonName="Decline Request" variant="danger" buttonIcon={<Icon icon="carbon:close-filled" />} color="btndefault" buttonSize="full" onClick={handleDeclineLeave}
                isLoading={isDeclining}
              />
            </Grid>
          </Grid>
          <Modal
            title="Approve Current Leave"
            subtitle=""
            modalContent={
              <>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="success"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Approve Leave"
                    onClick={handleApproveLeave}
                    isLoading={isApproving}
                  />
                </div>
              </>
            }
            isopen={approveModal}
            closeModal={() => {
              setApproveModal(false);
            }}
          />
          <Modal
            title="Decline Current Leave"
            subtitle=""
            modalContent={
              <>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="success"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Decline Leave"
                    onClick={handleDeclineModal}
                    isLoading={isDeclining}
                  />
                </div>
              </>
            }
            isopen={declineModal}
            closeModal={handleCloseDeclineModal}
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default LeaveMgtDetails;
